import actionCreator from '../../createAction';

const createAction = actionCreator('session');

export const LOGIN = createAction('LOGIN');
export const LOGOUT = createAction('LOGOUT');
export const RESTORE_TOKEN = createAction('RESTORE_TOKEN');
export const GET_ME = createAction('GET_ME');
export const SKIP_ONBOARDING = createAction('SKIP_ONBOARDING');
export const GET_USER_ACCOUNTS = createAction('GET_USER_ACCOUNTS');
export const GET_CONNECTIONS = createAction('GET_CONNECTIONS');
export const SET_THEME = createAction('SET_THEME');